module.exports = __webpack_public_path__ + "static/media/bg_16.cc8ae204.png";